import { render, staticRenderFns } from "./businessnew.vue?vue&type=template&id=63e6cb24&scoped=true&"
import script from "./businessnew.vue?vue&type=script&lang=js&"
export * from "./businessnew.vue?vue&type=script&lang=js&"
import style0 from "./businessnew.vue?vue&type=style&index=0&id=63e6cb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6cb24",
  null
  
)

export default component.exports